export class CategoryCoverType {
  id: number

  imgPath: string

  coverName: string
}
